// subscription-fix.js
//
// Fixes a bug in the Shopify Subscriptions app's product-page widget:
// switching the purchase-option tab from "Subscription" back to
// "One-time purchase" updates the visible UI, but the app's own script
// (app-block.js -> listenToOtpTabClick) never clears the hidden
// `selling_plan` field that actually gets submitted with the
// /cart/add form. Result: a customer who picks a subscription, then
// changes their mind and clicks "One-time purchase", still has the
// product added as a subscription — the cart/checkout silently keeps
// the previously-selected selling plan.
//
// This listens for the real, user-driven "change" events on the tab
// radios (input[id^="tab_otp_"] / input[id^="tab_subscribe_"]) — which
// do fire reliably, unlike the app's internal hidden purchase-option
// radios — and keeps the real `selling_plan` cart fields in sync.
// A capture-phase submit listener is a second line of defense in case
// any purchase-option widget on the page is added without going
// through the tab click handler below.
(function () {
  'use strict';

  function sellingPlanInputs(root) {
    return (root || document).querySelectorAll(
      'input[name="selling_plan"].selected-selling-plan-id, input[name="selling_plan"]'
    );
  }

  function clearSellingPlanInputs(root) {
    sellingPlanInputs(root).forEach(function (input) {
      input.value = '';
    });
  }

  function setSellingPlanInputs(root, planId) {
    sellingPlanInputs(root).forEach(function (input) {
      input.value = planId;
    });
  }

  function currentlyCheckedPlanId(card) {
    var checked = card.querySelector(
      'input[data-radio-type="selling_plan"]:checked, input[data-radio-type="selling_plan_group"]:checked'
    );
    return checked ? checked.getAttribute('data-selling-plan-id') : null;
  }

  function handleTabChange(e) {
    var tabRadio = e.target;
    if (!tabRadio.checked) return;

    var card = tabRadio.closest('.toggle_card') || document;

    if (tabRadio.id.indexOf('tab_otp_') === 0) {
      // Switched to "One-time purchase" — make sure no leftover
      // selling plan id is still sitting in the cart form.
      clearSellingPlanInputs(document);
    } else if (tabRadio.id.indexOf('tab_subscribe_') === 0) {
      // Switched to "Subscription" — belt-and-braces sync in case the
      // app's own handler hasn't run yet (e.g. no plan auto-selected).
      var planId = currentlyCheckedPlanId(card);
      if (planId) setSellingPlanInputs(document, planId);
    }
  }

  function bind(tabRadio) {
    if (tabRadio.__subscriptionFixBound) return;
    tabRadio.__subscriptionFixBound = true;
    tabRadio.addEventListener('change', handleTabChange);
  }

  function scan() {
    document
      .querySelectorAll('input[id^="tab_otp_"], input[id^="tab_subscribe_"]')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Purchase-option widgets can be (re)rendered after the initial load
  // (e.g. section rendering, quick-buy drawers) — keep watching for them.
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // Safety net: right before any add-to-cart submit, if the visible
  // "One-time purchase" tab is the one currently selected for this
  // product, strip any selling_plan value from that form so a stale
  // subscription selection can never sneak into the order.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;

      var variantInput = form.querySelector('input[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      var card = null;
      if (variantId) {
        document.querySelectorAll('.toggle_card').forEach(function (c) {
          if (!card && c.querySelector('input[data-variant-id="' + variantId + '"]')) {
            card = c;
          }
        });
      }

      var otpTab = card
        ? card.querySelector('input[id^="tab_otp_"]')
        : document.querySelector('input[id^="tab_otp_"]:checked');
      var subscribeTab = card ? card.querySelector('input[id^="tab_subscribe_"]') : null;

      var onOneTimeTab = otpTab && otpTab.checked && !(subscribeTab && subscribeTab.checked);

      if (onOneTimeTab) {
        clearSellingPlanInputs(form);
      }
    },
    true // capture phase — runs before Shopify's own submit handling
  );
})();
